// CSV export for the class, stablecoin and league tables: exactly the rows and
// columns on screen, a missing figure as an empty cell (never 0), and the
// data's as_of in the file name. The stocks grid has its own (stocksCsv).

export type CsvCell = string | number | boolean | null | undefined;

export interface CsvColumn<Row> {
  header: string;
  value: (row: Row) => CsvCell;
}

/** One cell, quoted; text that a spreadsheet would run as a formula is defused with a leading quote. */
export function csvCell(value: CsvCell): string {
  if (value === null || value === undefined || (typeof value === "number" && !Number.isFinite(value))) return '""';
  let text = String(value);
  if (typeof value === "string" && /^[=+@\-\t\r\n]/.test(text)) text = `'${text}`;
  return `"${text.replaceAll('"', '""')}"`;
}

export function toCsv<Row>(rows: readonly Row[], columns: ReadonlyArray<CsvColumn<Row>>): string {
  const header = columns.map((c) => csvCell(c.header)).join(",");
  return [header, ...rows.map((row) => columns.map((c) => csvCell(c.value(row))).join(","))].join("\n");
}

/** "treasury-entries-2026-10-08T0730Z.csv": the name, then the data's as_of in UTC (no colons, for every file system). */
export function csvFileName(base: string, asOf: string | null | undefined): string {
  const t = asOf ? Date.parse(asOf) : Number.NaN;
  if (!Number.isFinite(t)) return `${base}.csv`;
  const iso = new Date(t).toISOString();
  return `${base}-${iso.slice(0, 10)}T${iso.slice(11, 13)}${iso.slice(14, 16)}Z.csv`;
}

/** Saves the text as a file through a temporary link. */
export function downloadCsv(fileName: string, text: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: "text/csv;charset=utf-8" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
